<template>
  <div>
    <!--步骤条-->
    <el-steps :active='activeIndex' finish-status="success" align-center class="pt-5 pb-5" v-if="infoList.status!== 99 && infoList.status !== 100">
      <el-step title='提交订单'/>
      <el-step title='订单支付'/>
      <el-step v-if="infoList.type == 1" title='等待出票'/>
      <el-step v-if="infoList.type == 1" title='出票成功'/>
      <el-step v-if="infoList.type == 2" title='预订成功'/>
    </el-steps>
    <public-title>订单详情
      <span class="text-link ml-auto h6 btnback" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <!--主体内容-->
    <div class="bg-white p-4">
      <el-row>
        <el-col :span="24" class="text-right waitime">
          <h3 :class="['mb-3 pb-2',orderStatus.color]">
            <div id="remainTime">{{inner}}</div>
            <div>{{orderStatus.title}}</div>
          </h3>
        </el-col>
      </el-row>
      <basic-info :info-list="infoList"/>
      <div v-if="activeIndex === 1">
        <div class="d-center-between pt-4 pb-4 border-bottom">
          <h3 v-if="userLoginMessage.type != 99">扫码支付</h3>
          <p class="h5 d-center">应付金额 <span class="pl-2 h2 text-info pr-2">{{infoList.price}}</span>元 </p>
        </div>
       <div class="d-flex flex-column align-items-center" v-if="userLoginMessage.type != 99">
         <img v-if="QRcode" class="border rounded mt-4" style="width: 150px; height: 150px;" :src="QRcode" alt="">
         <el-button type="primary" class="m-4" @click="getQRcode">获取支付二维码</el-button>
       </div>
      </div>
      <div v-if="infoList.type == 2 && infoList.status == 9 && !infoList.check_code && userLoginMessage.type === 99">
        <div class="pt-4 pb-4 border-top gap text-left">
          <h3 class="pb-3">设置凭证信息<el-button type="primary" class="poof ml-3" @click="proof = !proof">凭证信息</el-button></h3>
          <div v-show="proof">
            <el-radio-group v-model="radio" @change="radioChoose">
              <el-radio :label="item.id" v-for="item in $GVAR.ScenicCheckType" :key="item.name">{{item.name}}</el-radio>
            </el-radio-group>
            <el-input class="mt-2" v-model="code" placeholder="请输入相应取票凭证信息" />
            <div class="pt-4 pb-4 gap text-left">
              <h3>出行日期</h3>
              <el-date-picker
                class="mt-3" size="small"
                v-model="outTime"
                type="date"
                placeholder="如：2019-02-13"
                format="yyyy - MM - dd"
                value-format="timestamp">
              </el-date-picker>
            </div>
            <div class="waitbtns">
                <el-button type="primary" round @click="proof = false">取&nbsp;&nbsp;消</el-button>
                <el-button type="success" round @click="confirmorder">确&nbsp;&nbsp;认</el-button>
            </div>
          </div>
        </div>
        
      </div>
      <div v-if="infoList.type == 2 && infoList.status == 9 && !infoList.check_code && userLoginMessage.type != 99" class="text-info h3">
        支付成功，使用前请与客服人员预约使用时间，预约热线：0571-89986918。
      </div>
      <div v-if="activeIndex === 2">
        <div v-if="userLoginMessage.type === 99 && !infoList.check_code">
          <div class="pt-4 pb-4 border-top text-left">
            <h3 class="pb-3">设置取票方式</h3>
            <el-radio-group v-model="radio" @change="radioChoose">
              <el-radio :label="item.id" v-for="item in $GVAR.ScenicCheckType" :key="item.name">{{item.name}}</el-radio>
            </el-radio-group>
            <el-input class="mt-2" v-model="code" placeholder="请输入相应取票凭证信息"/>
          </div>
          <div class="waitbtns">
            <el-button type="primary" round @click="cancelorder">取&nbsp;&nbsp;消</el-button>
            <el-button type="success" round @click="confirmorder">确&nbsp;&nbsp;认</el-button>
          </div>
        </div>
        <div v-if="activeIndex != 2 && infoList.type == 1">
          <h2 style="color:orange">支付成功，请耐心等待平台确认。。。</h2>
        </div>
      </div>
      <!-- <div v-if="activeIndex === 3">
        <div class="d-flex justify-content-end border-bottom">
          <p class="h5 d-center pt-4 pb-4">已付金额 <span class="pl-2 h2 text-info pr-2">{{infoList.price}}</span>元 </p>
        </div>
        <p class="m-5 h4 text-login d-center">
          <i class="iconfont pr-2" style="font-size: 50px">&#xe62b;</i>
          <span>订单完成！</span>
        </p>
      </div>
      <div v-if="activeIndex === 99 && infoList.price_pay > 0">
            <p class="h4 pt-4">订单已取消，钱已原路退回！</p>
      </div> -->
    </div>
  </div>
</template>

<script>
  import { mapState,mapActions } from 'vuex'
  import BasicInfo from './Comps/BasicInfo'

  export default {
    name: 'VocationQR',
    computed:{
      ...mapState(['userLoginMessage', 'newMessageInform']),
      orderStatus() {
        let status = {};
        switch (this.infoList.status) {
          case 8 : status = {type: 8, title: '待支付', color: 'text-info'}; break;
          case 9 : status = {type: 9, title: '已完成', color: 'text-success'}; break;
          case 14 : status = {type: 14, title: '待确认', color: 'text-blue'}; break;
          case 99 : status = {type: 99, title: '超时取消', color: 'text-muted'}; break;
          case 100 : status = {type: 100, title: '已取消', color: 'text-muted'}; break;
        }
        return status;
      },
      StoreElse () {
        return this.userLoginMessage.type == 3 || this.userLoginMessage.type == 5 ||  this.userLoginMessage.type == 6
      },
    },
    components:{BasicInfo},
    data() {
      return {
        activeIndex:1,
        infoList:{},                             //获取的订单信息
        QRcode:false,                           //获取二维码图片
        radio: 1,
        code: '',
        inner: '',
        outTime: '',
        proof: false
      }
    },
    created() {
      this.getBasicInfo();
    },
    watch: {
      newMessageInform(newVal) {
        //if (this.newMessageInform.type === 12 || this.newMessageInform.type === 13 || this.newMessageInform.type === 32) {
        if (newVal) {
          this.QRcode = '';
          this.activeIndex = 2;
          clearInterval(this.interval)
          this.interval = null
          this.getBasicInfo()
          if (this.StoreElse) this.getBuyWaitData()
        }
      },      
      'infoList.status'(val) {
        switch (val) {
          case 8 : this.activeIndex = 1; break;
          case 9 : this.activeIndex = 4; break;
          case 14: this.activeIndex = 2; break;
          case 99:
          case 100:
            this.activeIndex = 99; break;
        }
        if (val === 8) {
          this.countdown(1800000, 'time')
        } else if (val === 14) {
          this.countdown(1800000, 'deal')      //之前待确认15分钟现在30分钟
        }
      },

    },
    beforeDestroy() {
      clearInterval(this.interval)
      this.interval = null
    },
    methods:{
      ...mapActions(['getBuyWaitData']),
      radioChoose () {
        if (this.radio == 1) {
          this.code = this.infoList.id_card;
        } else if (this.radio == 2) {
          this.code = this.infoList.occupant_mobile;
        } else {
          this.code = ''
        }
      },
      async getBasicInfo() {
        let url
        let data = { id:this.$route.query.id }
        if (this.$route.query.type == 7) url = '/pc/Reglogin/getProductOrderDetail'
        else { url = '/pc/Tourist/getViewpointOrderDetail'; data.is_login = 1}
        let res = await this.$axios.post(url,data);
        if (res.code === '00000') this.infoList = res.data || res.info;
        this.code = this.infoList.id_card
      },
      async cancelorder() {
         let res = await this.$axios.post('/pc/Admin/cancelProductOrder',{
            oid:this.$route.query.id,
          });
         if (res.code === '00000') this.getBasicInfo();
         this.$message(res.msg)
         clearInterval(this.interval)
         this.interval = null
         this.inner = ''
      },
      async confirmorder() {
        if (!this.code) {
          this.$message('请输入相应取票凭证信息')
          return
        }
        if (this.radio == 1) {
          if (!this.$GFUN.isIDexist(this.code)) {
            this.$message('请填写正确的身份证号码')
            return
          }
        } else if (this.radio == 2) {
          if (!this.$GFUN.isPhone(this.code)) {
            this.$message('请填写正确的手机号码')
            return
          }
        }
        if (this.outTime == 0 && this.infoList.type == 2) {
          this.$message('请选择出行日期')
          return
        }
        let datetime = 0
        if (this.infoList.type == 1) {
          datetime = this.infoList.date_in
        } else {
          datetime = this.outTime / 1000
        }
        let res = await this.$axios.post('/pc/Admin/checkProductOrder',{
            oid: this.$route.query.id,
            check_type: this.radio,
            check_code: this.code,
            date_in: datetime
        });
        if (res.code === '00000') {
          this.getBasicInfo();
          this.$message(res.msg)
          clearInterval(this.interval)
          this.interval = null
          this.inner = ''
        }
      },
      getQRcode() {
        let count = new Date().getTime();
        let type = '11'
        if (this.$route.query.type == 6) type = '10_2'
        this.QRcode = `${this.BASE_URL}/pc/Common/getPayQrcode?needToken=${this.userLoginMessage.token}&version=${window.localStorage.getItem('VERSION')}&needType=1&hotel_id=${this.infoList.appoint}&oid=${this.infoList.id}&price_fen=${this.infoList.price * 100}&order_pay_id=null&source=1&order_pay_type=${type}&count=${count}`;
      },
      countdown (lose, status) {
        let that = this
        let now = new Date().getTime()
        let end = 0
        if (status === 'deal') {
          end = this.infoList.deal_time * 1000 + lose //提交订单的时间+30min就是订单失效时间
        } else {
          end = this.infoList.time * 1000 + lose //提交订单的时间+30min就是订单失效时间
        }        
        /*两个时间相减,得到的是毫秒ms,变成秒*/
        var result = Math.floor(end - now) / 1000 //result= 30*60s;
        this.interval = setInterval(sub, 1000) //定时器 调度对象
        /*封装减1秒的函数*/
        function sub() {
          if (result > 1) {
              result = result - 1
              var second = Math.floor(result % 60)    // 计算秒 ，取余
              var minite = Math.floor((result / 60) % 60) //计算分 ，换算有多少分，取余，余出多少秒
              if (second < 10) {
                that.inner = '剩余：' + minite + '分0' + second + '秒'
              } else {
                that.inner = '剩余：' + minite + '分' + second + '秒'
              }              
          } else {
            clearInterval(that.interval)           
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.btnback{
  color: #fff;
  background-color: var(--smtc-color-primary);
  border-color: var(--smtc-color-primary);
  -webkit-box-shadow: 0 10px 5px -5px #e1e1e1;
  box-shadow: 0 10px 5px -5px #e1e1e1;
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
}
.poof{
  border-radius: 15px;
  font-size: 14px;
  padding: 8px 10px
}
.waitime{
    h3{
      div{
        display: inline-block;
        margin-left: 10px
      }
    }
  }
.waitbtns{
  margin-top: 120px;
  margin-bottom: 120px;
  text-align: center;
  .is-round{
    font-size: 18px;
    border-radius: 15px;
    padding: 8px 40px;
    margin-left: 10%;
    margin-right: 10%
  }
}
</style>
